import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconArrowLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 19,
	height: 15,
	viewBox: "0 0 19 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.85713 13.7142L1.42856 7.28566M1.42856 7.28566L7.85713 0.85709M1.42856 7.28566L18.5714 7.28567",
		fill: "currentColor",
		strokeWidth: 1.2
	})
});
export default SvgIconArrowLeft;
